import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';

interface InterruptedModalProps {
  isOpen: boolean;
  onClosed: () => void;
  reOpenFormModal: () => void;
}

const InterruptedModal: FC<InterruptedModalProps> = ({ isOpen, onClosed, reOpenFormModal }) => {
  return (
    <VbzModal isOpen={isOpen} type="right" desktopSize="small" toggle={onClosed}>
      <ModalBody>
        <div className="modal-title">
          <h3>Sua solicitação ainda não foi concluída</h3>
        </div>
        <div className="modal-description-interrupted">
          <p>O formulário não será enviado se você sair da página.</p>
        </div>
        <div className="vbz-button-submit">
          <VbzButton
            id="submit-modal"
            className="mt-5 smls-register-cpf upgrade-modal-button"
            color="primary"
            text="Solicitar pontos retroativos"
            onClick={() => {
              reOpenFormModal();
              onClosed();
            }}
          />
        </div>
        <VbzButton
          className="voebiz-register-hyperlink"
          color="hyperlink"
          text="Voltar para o início"
          onClick={onClosed}
        />
      </ModalBody>
    </VbzModal>
  );
};

export default InterruptedModal;
